import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import fetchCompanies from '../api/fetchCompanies';
import type { ApiResponse } from '../../../types/apiResponse';
import type { CompanyUser } from '../types';
export const useFetchCompanies = (): UseQueryResult => {
    return useQuery<ApiResponse<CompanyUser[]>>({
        queryKey: ['companies'],
        queryFn: fetchCompanies,
    });
};
